export const MIN_MAX = {
    RULE_ENTRY: "rule-entry",
    ADD_RULE: "add-rule",
    RULE_TYPE: "rule-type",
    AMOUNT_FIELD: "amount-field",
    AMOUNT_TYPE: "amount-type",
    ORDER_RESTRICTION: "order-restriction",
    LINE_ITEM_RESTRICTION: "line-item-restriction",
    SIZE_RESTRICTION: "size-restriction",
    GROUP_RESTRICTION: "group-restriction",
    RESTRICTION_FIELD_MENU: "restriction-field-menu",
    RESTRICTION_FIELD_VALUES: "restriction-values-input",
    ACTION_MENU: "action-menu",
    EDIT_RULE: "edit-rule",
    DELETE_RULE: "delete-rule",
    NEXT_STEP_INVALID: "next-step-invalid",
    NEXT_STEP_VALID: "next-step-valid",
    ERROR_MESSAGE_INPUT: "error-message-input",
    READ_ONLY_ERROR_MESSAGE: "read-only-error-message",
    SAVE_INVALID: "save-invalid",
    SAVE_VALID: "save-valid",
    ORDER_FIELD_SELECTOR: "order-field-selector",
    DELETE_RESTRICTION_FIELD: "delete-restriction-field",
    STEP_ZERO_CONTAINER: "zero-step-container",
};
